import { render, staticRenderFns } from "./Panel.vue?vue&type=template&id=33c66bcd&scoped=true&"
import script from "./Panel.vue?vue&type=script&lang=ts&"
export * from "./Panel.vue?vue&type=script&lang=ts&"
import style0 from "./Panel.vue?vue&type=style&index=0&id=33c66bcd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c66bcd",
  null
  
)

export default component.exports